defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/ThemeDesignTab',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/ClubSettings/ThemeDesignOptions',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard'
  ],
  function (m, PlayTogetherApi, CtaButton, CardContent, ThemeDesignOptions, PostCard) {
    const ThemeDesignTab = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.saveButtonText = this.rootDictionary.get('Shared/SaveButton');
        this.themeDesignTabDictionary = this.rootDictionary.get.bind({ prefix: 'ClubSettings/ThemeDesignTab/' });

        this.save = () => {
          this.processing(true);
          PlayTogetherApi.updateClub(this.clubId(), this.clubModel().toJSON())
            .then(() => {
              this.processing(false);
            })
            .catch((response) => {
              this.processing(false);
              this.error(response);
            });
        };
      },

      view: function (controller, ignoreArgs, $slots) {
        const className = () => {
          let className = '';

          if (!controller.isCurrentUserChairman()) {
            className += ' club-settings--not-chairman';
          }

          return className;
        };

        const $content = () => {
          return [
            !controller.isCurrentUserChairman() ? PostCard({
              icon: 'lock',
              title: controller.dictionary('NotChairmanCard/Title'),
              description: controller.dictionary('NotChairmanCard/Description'),
            }) : null,
            m(ThemeDesignOptions, { controller: controller })
          ];
        };

        const $footer = CtaButton({
          text: controller.saveButtonText,
          onClick: controller.save,
          className: 'yellow',
          loading: controller.processing()
        });

        return CardContent({
          className: className(),
          title: controller.themeDesignTabDictionary('Title'),
          subtitle: controller.themeDesignTabDictionary('Subtitle'),
          $header: $slots.header,
          $content: $content(),
          $footer
        });
      }
    };

    return ThemeDesignTab;
  });
